import {FC} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Information from 'components/Information';
import {useBackend} from 'state/backend';
import {EmployeeRightsCreateBackendData} from '../../types';

type UpgradeMessageProps = {
    className?: string;
};

const UpgradeMessage: FC<UpgradeMessageProps> = ({className}) => {
    const {t} = useTranslation('Team.Member.EmployeeRights');

    const {
        data: {
            userLicense: {displayUpgradeMessage},
        },
    } = useBackend<EmployeeRightsCreateBackendData>();

    if (!displayUpgradeMessage) return null;

    return (
        <Information className={className} type="alert">
            <Trans
                components={[
                    <a key={0} href={window.Urls.billing_index()}>
                        {' '}
                    </a>,
                ]}
                i18nKey="upgrade"
                t={t}
            />
        </Information>
    );
};

export default UpgradeMessage;
